
import { WeddingEventImage } from 'ignite360-core';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'share-button',
})
export default class ShareButton extends Vue {
  async handleShare() {
    const imageUrl = window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Wedding Photo',
          text: 'Check out this wedding photo!',
          url: imageUrl,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      // Fallback to copying the URL
      try {
        await navigator.clipboard.writeText(imageUrl);
        // You might want to add a toast notification here
        console.log('Image URL copied to clipboard');
      } catch (error) {
        console.error('Error copying to clipboard:', error);
      }
    }
  }
}
